import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import OfferFloatActionButton from 'component/offer/OfferFloatActionButton';
import ActivityLogSection from 'component/profile/ActivityLogSection';
import LevelBenefit from 'component/profile/LevelBenefit';
import LevelRuleSection from 'component/profile/LevelRuleSection';
import LevelSectionV2 from 'component/profile/LevelSectionV2';
import PointAndCashSection from 'component/profile/PointAndCashSection';
import RetainMembershipSection from 'component/profile/RetainMembershipSection';
import LevelHasRetainInfo from 'component/profile/LevelHasRetainInfo';
import RewardStatusSection from 'component/profile/RewardStatusSection';
import TransactionHistorySection from 'component/profile/TransactionHistorySection';
import SignInMobile from 'container/SignInMobile';

import MobileViewPointAndCashInfo from './MobileViewPointAndCashInfo';
import MobileViewProfileSubNavigator from './MobileViewProfileSubNavigator';
import MyCouponsMobileSection, {
  MyCardMobileSection,
  MyTicketsMobileSection,
} from './MyCouponsMobileSection';
import NoLevelSection from './NoLevelSection';

import { NO_TRANSACTION_HISTORY } from 'utils/Config';
import { detectIsPadOrMobileByScreenWidth } from 'utils/ScreenUtils';
import ServerConfig from 'utils/ServerConfig';

import './MyProfileContentSection.scss';

@connect(({ users }) => ({
  showLevelRetain: users.showLevelRetain,
  isLogin: users.isLogin,
  language: users.language,
  showLevelHasRetain: users.showLevelHasRetain,
}))
class MyProfileContentSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelectedLevelView: 0,
      isMobile: detectIsPadOrMobileByScreenWidth(),
    };
  }

  updateWindowDimensions = () => {
    this.setState({ isMobile: detectIsPadOrMobileByScreenWidth() });
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  MyProfileContentDesktop = (showRetainMembershipSection) => {
    return (
      <>
        <div className="my-profile-content-section">
          {!ServerConfig.getNoLevel() ? <LevelSectionV2 /> : <NoLevelSection />}
          <div
            className={`my-profile-content-right-area ${
              !ServerConfig.getNoLevel() ? '' : 'no-level'
            }`}
          >
            <PointAndCashSection />
            {!ServerConfig.getNoLevel() && (
              <div className="level-info-area">
                <LevelRuleSection />
                <LevelBenefit />
              </div>
            )}
          </div>
        </div>
        {showRetainMembershipSection && (
          <Row className="my-profile-content-section">
            <RetainMembershipSection />
          </Row>
        )}
        {this.props.showLevelHasRetain && (
          <Row className="my-profile-content-section">
            <LevelHasRetainInfo />
          </Row>
        )}
        <ActivityLogSection />
        {NO_TRANSACTION_HISTORY ? null : <TransactionHistorySection />}
        <RewardStatusSection />
        <OfferFloatActionButton />
      </>
    );
  };

  MyProfileContentMobile = (showRetainMembershipSection) => {
    if (!this.props.isLogin) {
      return <SignInMobile />;
    }
    return (
      <div className="my-profile-content-section mobile-view">
        <div className="level-and-point">
          <MobileViewPointAndCashInfo />
          {!ServerConfig.getNoLevel() ? <LevelSectionV2 /> : <NoLevelSection />}
          {showRetainMembershipSection ? <RetainMembershipSection /> : null}
          <LevelHasRetainInfo />
          {ServerConfig.getNoTicket() ? (
            <div className="coupons-and-tickets">
              <MyCardMobileSection />
              <MyCouponsMobileSection />
            </div>
          ) : (
            <div className="coupons-and-tickets">
              <MyCouponsMobileSection />
              <MyTicketsMobileSection />
            </div>
          )}
          <PointAndCashSection />
        </div>
        <MobileViewProfileSubNavigator />
      </div>
    );
  };

  render() {
    const showRetainMembershipSection = this.props.showLevelRetain;
    return (
      <>
        {this.state.isMobile
          ? this.MyProfileContentMobile(showRetainMembershipSection)
          : this.MyProfileContentDesktop(showRetainMembershipSection)}
      </>
    );
  }
}

export default withTranslation()(MyProfileContentSection);
